<script lang="ts">
import validationErrors from "@/shared/mixins/validationErrors";
export default defineComponent({
  name: "FooterLayout",
  mixins: [validationErrors],
});
</script>

<script setup lang="ts">
import tradutor from "@/tradutors/mainfooter";
import translateMain from "@/tradutors/menu";
import api from "@/api";
import { isMobile } from "@/shared/utils/mobile";

import { useSocialNetworks, socialNetworksFor } from "@/composables/useSocialNetworks";

const router = useRouter();

const emits = defineEmits(["showModalMessages"]);

const storeLocale = localeStore();
const reactiveLocale = computed(() => router.currentRoute.value.params.language);

const translate = computed(() => {
  if (reactiveLocale.value === "pt-br") {
    return tradutor.portugues;
  } else {
    return tradutor.ingles;
  }
});

const translatemain = computed(() => {
  if (reactiveLocale.value === "pt-br") {
    return translateMain.portugues;
  } else {
    return translateMain.ingles;
  }
});

// Conteúdo "Sobre o Bella" alimentado pelo admin (tabela config). Fallback por
// campo para os textos estáticos de mainfooter.ts quando vier vazio/inexistente.
const about = await useSeoAbout(String(reactiveLocale.value));
const aboutTitle = computed(() => about.value?.title || translate.value.menu.aboutTitle);
const aboutText = computed(() => about.value?.text || translate.value.menu.footerDescription);
const aboutLinkLabel = computed(() => about.value?.link || translate.value.menu.btnSeeMore);

const now = computed(() => {
  return new Date().getFullYear();
});

const email = ref("");

// Mesma chave de useAsyncData do Header e do Navbar: uma requisição serve os três.
const socialNetworks = await useSocialNetworks(String(reactiveLocale.value));
const icones = computed(() => socialNetworksFor(socialNetworks.value, "footer"));

function redirect(name: string) {
  router.push({ name, params: { language: router.currentRoute.value.params.language } });
}
function addToNewsletter() {
  api
    .post("v1/newsletter/storeNewsletterApi?email=" + email.value)
    .then(({ data }) => {
      emits("showModalMessages", {
        message: {
          show: true,
          title: "",
          textBoby: data.return,
          textButton: "Fechar",
        },
      });
    });
}
</script>
<template>
  <footer class="l-footer">
    <div class="container">
      <div class="row">
        <div class="col-12 col-xl-3 order-first order-xl-1 about-section">
          <h2 class="about-title">{{ aboutTitle }}</h2>
          <p class="summary" v-text="aboutText" />
          <div class="link-about" @click="redirect('language-sobre')">
            {{ aboutLinkLabel }} <i class="icon-arrow-right"></i>
          </div>
        </div>
        <!-- Menu do desktop e lista do mobile vão os dois no HTML do SSR e o CSS
             escolhe (< 770): com v-if no isMobile(), false no servidor, o mobile
             recebia o menu do desktop e a hidratação divergia -->
        <div class="col-12 col-md-12 order-2 col-xl-6 order-xl-2 mt-2 footer-nav-desktop">
          <div class="nav">
            <ul class="d-flex">
              <li>
                <span @click="redirect('language-freetour')">
                  {{ translate.menu.freetour }}
                </span>
              </li>
              <li>
                <span @click="redirect('language-colunas')">
                  {{ translate.menu.colums }}
                </span>
              </li>
              <li>
                <NuxtLink :to="`/${reactiveLocale}/afiliado`">
                  {{ translate.menu.parceiro }}
                </NuxtLink>
              </li>
              <li>
                <span @click="redirect('language-modelos')">
                  {{ translate.menu.modelos }}
                </span>
              </li>
              <li>
                <span @click="redirect('language-ecards')">
                  {{ translate.menu.ecard }}
                </span>
              </li>
              <li>
                <a href="#">
                  {{ translate.menu.edicoes }}
                </a>
              </li>
              <li>
                <span @click="redirect('language-videos')">
                  {{ translate.menu.videos }}
                </span>
              </li>
              <li>
                <span @click="redirect('language-bellacloud')">
                  {{ translate.menu.bellacloud }}
                </span>
              </li>
              <li>
                <span @click="redirect('language-programa-afiliados')">
                  {{ translate.menu.afiliados }}
                </span>
              </li>
              <li>
                <span @click="redirect('language-blog')">
                  {{ translate.menu.blog }}
                </span>
              </li>
              <li>
                <span @click="redirect('language-contato')">
                  {{ translate.menu.contato }}
                </span>
              </li>
              <li>
                <span @click="redirect('language-imprensa')">
                  {{ translate.menu.imprensa }}
                </span>
              </li>
              <li>
                <span @click="redirect('language-making-of')">
                  {{ translate.menu.makingof }}
                </span>
              </li>
              <li>
                <span @click="redirect('language-lives')">
                  {{ translate.menu.lives }}
                </span>
              </li>
              <!-- a grade tem 3 colunas preenchidas por linha: o último item fica embaixo de Imprensa -->
              <li>
                <span @click="redirect('language-publicidade')">
                  {{ translate.menu.publicidade }}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 order-2 order-xl-2 footer-nav-mobile">
          <hr style="margin: 0px 0px 30px" />
          <div class="text-center">
            <ul class="w-100">
              <li>
                <span @click="redirect('language-politica-de-privacidade')">
                  {{ translate.menu.privacidade }}
                </span>
              </li>
              <li>
                <span @click="redirect('language-politica-de-cancelamento')">
                  {{ translate.menu.cancelamento }}
                </span>
              </li>
              <li>
                <span @click="redirect('language-programa-afiliados')">
                  {{ translate.menu.afiliados }}
                </span>
              </li>
              <li>
                <NuxtLink :to="`/${reactiveLocale}/afiliado`">
                  {{ translate.menu.parceiro }}
                </NuxtLink>
              </li>
              <li>
                <a href="#">
                  {{ translate.menu.edicoes }}
                </a>
              </li>
              <li>
                <span @click="redirect('language-imprensa')">
                  {{ translate.menu.imprensa }}
                </span>
              </li>
              <li>
                <span @click="redirect('language-publicidade')">
                  {{ translate.menu.publicidade }}
                </span>
              </li>
              <li>
                <span @click="redirect('language-contato')">
                  {{ translate.menu.contato }}
                </span>
              </li>
            </ul>
          </div>
          <hr style="margin: 50px 0px 30px; color: #333333" />
        </div>
        <div class="col-12 col-md-12 order-1 col-xl-3 order-xl-3 px-3">
          <div class="newsletter">
            <ClientOnly>
              <h3 class="newsletter__title" v-text="isMobile() ? translate.menu.news2 : translate.menu.news" />
            </ClientOnly>
            <h3
              class="newsletter__title-b"
              v-text="translate.menu.newsDescription"
            ></h3>
            <div class="newsletter__textbox">
              <form @submit.prevent="addToNewsletter">
                <input
                  type="email"
                  name="email"
                  :placeholder="translate.menu.email"
                  required
                  v-model="email"
                  @keyup.enter="addToNewsletter"
                  style="color: #999999"
                />
                <button type="submit" aria-label="Newsletter">
                  <i class="icon-arrow-right"></i>
                </button>
              </form>
            </div>
            <small v-text="translate.menu.emailDescription" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-3">
          <!-- Social Links -->
          <ul v-if="icones.length" class="social-box">
            <li v-for="icon in icones" :key="icon.slug" :class="`social-icon--${icon.slug}`">
              <a :href="icon.url" target="_blank" rel="noopener noreferrer"
                ><img
                  :src="icon.icon"
                  :alt="icon.name"
                  width="23"
                  height="23"
                  class="icon-header"
                  loading="lazy"
              /></a>
            </li>
          </ul>
        </div>
        <div class="col-12 col-xl-9 m-bottom d-flex">
          <div class="privacy col-lg-2 col-6 text-center" @click="redirect('language-politica-de-privacidade')">
            {{ translate.menu.privacidade }}
          </div>
          <div class="privacy col-lg-2 col-6 text-center" @click="redirect('language-politica-de-cancelamento')">
            {{ translate.menu.cancelamento }}
          </div>
        </div>
      </div>
      <div class="copy">
        <p>
          © 2001 - {{ now }}. Bella da Semana.
          {{ translatemain.copia }}.
        </p>
        <p v-text="translate.menu.declaracao"></p>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.about-title,
h3 {
  color: #ffffff;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
  margin-bottom: 5px;
}

.newsletter__textbox input {
  height: 15px;
  color: #ffffff;
  font-family: "Roboto-Regular";
  font-size: 13px;
  letter-spacing: 0;
  line-height: 15px;
  position: relative;
  width: 100%;
  height: 100%;
  text-align: start;
  padding: 17px 20px;
  border: none;
  background: none;
  outline: none;
}

.link-about {
  cursor: pointer;
}

.l-footer .newsletter__title {
  display: block;
}

.l-footer .newsletter {
  margin-bottom: -10px;
}

.l-footer .copy:before {
  margin-top: 30px;
  margin-bottom: 30px;
}

.l-footer {
  padding-top: 50px;
}

.summary {
  color: #999999;
  font-family: "Roboto-Regular";
  font-size: 13px;
  letter-spacing: 0;
  line-height: 15px;
}

.l-footer .summary {
  margin-bottom: 5px;
}

.link-about {
  color: #999999;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  margin-bottom: 35px;
}

.l-footer .nav ul li a,
.l-footer .nav ul li span {
  color: #ffffff;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  cursor: pointer;
}

.l-footer .nav ul li {
  margin-bottom: 12px;
}

.newsletter__title {
  color: #ffffff;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  margin-top: 12px;
}

.newsletter small {
  color: #999999;
  font-family: "Roboto-Regular";
  font-size: 13px;
  letter-spacing: 0;
  line-height: 15px;
}

.copy p {
  color: #999999;
  font-family: "Roboto-Regular";
  font-size: 11px;
  letter-spacing: 0;
  line-height: 13px;
}

.order-xl-1 {
  margin-top: 3px;
  padding-left: 14px;
}

.social-box {
  margin-left: -7px;
}

.l-footer .social-box li {
  margin-right: 10px;
}

.privacy {
  color: #999999;
  cursor: pointer;
}

.l-footer .privacy:first-child {
    margin-left: -10px;
}

/* Tablet/iPad retrato (770–991px): nesta faixa os .privacy são col-6 (50% cada)
   e já preenchem a linha; o margin-right:70px do primeiro (definido em
   _footer.scss para o desktop, onde são col-lg-2 estreitos) empurra o segundo
   link para fora → 48px de overflow horizontal. Como .l-header é fixed sem
   left/right e .custom-container tem largura fixa (= screen.availWidth), esse
   overflow desloca o header (corta o MENU) e vaza a faixa preta à direita em
   TODAS as páginas. Zerar o espaçamento aqui; em >=992px (col-lg-2) ele permanece. */
@media screen and (min-width: 770px) and (max-width: 991px) {
  .l-footer .privacy:first-child {
    margin-right: 0;
  }
}

@media screen and (min-width: 770px) and (max-width: 1200px) {
  .l-footer .newsletter {
      margin-bottom: 50px;
  }  

  .copy {
      margin-top: 40px !important;
  }  
}

.footer-nav-mobile {
  display: none;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .footer-nav-desktop {
    display: none;
  }
  .footer-nav-mobile {
    display: block;
  }

  .l-footer {
    padding-top: 0px;
  }

  .newsletter__title {
    color: #ffffff;
    font-family: "Roboto-Medium";
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
    margin-top: 25px;
    text-align: center;
  }

  .newsletter__title-b {
    margin-bottom: 5px;
  }

  .newsletter small {
    color: #999999;
    font-family: "Roboto-Regular";
    font-size: 13px;
    letter-spacing: 0;
    line-height: 15px;
    margin-bottom: 50px;
  }

  .copy p {
    color: #999999;
    font-family: "Roboto-Regular";
    font-size: 13px;
    letter-spacing: 0;
    line-height: 15px;
    padding: 0 22px;
  }

  .l-footer ul li a,
  .l-footer ul li span {
    display: block;
    height: 19px;
    color: #ffffff;
    font-family: "Exo-2";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    padding: 25px 0px;
  }

  .l-footer .privacy:first-child {
    margin-right: unset; 
    margin-left: unset;
  }
  .m-bottom {
    margin-bottom: 50px;
  }

  .newsletter__title-b {
    margin-bottom: 25px;
  }

  /* Seção "Sobre" (GEO) visível no mobile, alinhada ao rodapé */
  .about-section {
    margin-top: 50px;
    padding: 0 22px 10px;
    text-align: center;
  }

  .about-section .summary {
    margin-bottom: 12px;
  }

  .about-section .link-about {
    margin-bottom: 30px;
  }
  .about-title {
    margin-bottom: 15px;
  }
}
</style>
